import { render, staticRenderFns } from "./adinfo.vue?vue&type=template&id=5de35a8a&"
import script from "./adinfo.vue?vue&type=script&lang=js&"
export * from "./adinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports